import { urlQuery } from 'utils/url';
import { setConfig } from 'helper/configManager';

const config = {
  sourceId:
    typeof urlQuery.sourceid !== 'undefined' && urlQuery.sourceid !== ''
      ? urlQuery.sourceid
      : 8,
  apiEndpoint: '//w2api.lifevc.com/',
};
let envConfig;

let env = process.env.FEA_APP_CONFIG;
if (process.env.NODE_ENV === 'development') {
  env = 'test';
}

if (env === 'test') {
  envConfig = {
    apiEndpoint: '//w2api-test.lifevc.com/',
    apiAltEndpoint: '//rest-test.lifevc.com/',
    apiToken: 'QWN0QXBpfDEyNHM0ZGNib2luYjg0NTg0NzEyYm9pZWdrZmpr',
    wxAuthHost: 'w2api-test.lifevc.com',
    wxAppId: 'wx744e8b104c3a3c9f',
  };
} else if (env === 'pre') {
  envConfig = {
    // apiEndpoint: '//w2api-pre.lifevc.com/',
    apiAltEndpoint: '//rest-pre.lifevc.com/',
    apiToken: 'QWN0QXBpfDZjYXRyZW9mMGpwbzM4ZWI0MElINDY1ZGtsZnVv',
    wxAuthHost: 'w2api.lifevc.com',
    wxAppId: 'wx649fd2d75cb908dd',
  };
} else {
  envConfig = {
    // apiEndpoint: '//w2api.lifevc.com/',
    apiAltEndpoint: '//rest.lifevc.com/',
    apiToken: 'QWN0QXBpfDZjYXRyZW9mMGpwbzM4ZWI0MElINDY1ZGtsZnVv',
    wxAuthHost: 'w2api.lifevc.com',
    wxAppId: 'wx649fd2d75cb908dd',
  };
}

setConfig({ ...config, ...envConfig });
